angular.module('bribac.entities.noteFactory', [])

  .value('noteFactory', function noteFactory(data) {
    return angular.merge({
      id: null,
      author: null,
      subject: null,
      text: null
    }, data)
  })
